<p-table
    #table
    [value]="prezzi"
    [columns]="colonne" [reorderableColumns]="true"
    responsiveLayout="stack"
    [breakpoint]="'960px'"
    styleClass="scheda-tabella p-datatable-sm"
    [paginator]="true"
    [showCurrentPageReport]="true"
    [rowHover]="true"
    [globalFilterFields]="['settore']"
    currentPageReportTemplate="{first} di {last} su {totalRecords} prezzi"
    [rows]="5" [rowsPerPageOptions]="[5, 10, 20, 50]">
    <ng-template pTemplate="caption">
        <div class="flex lg:flex-row flex-col gap-3 w-full">
            <div class="lg:w-3/4 w-full">
                <p-iconfield iconPosition="left" [style]="{'width': '100%'}">
                    <p-inputicon styleClass="bi bi-search" />
                    <input type="text" pInputText (input)="onGlobalFilter(table, $event)" placeholder="Cerca prezzi…" [style]="{'width': '100%'}" />
                </p-iconfield>
            </div>
            <div class="lg:w-1/4 w-full table-toolbar-btns">
                <button class="flex-1 acc-btn" type="button" (click)="add = true">
                    <i class="bi bi-plus"></i>
                    Aggiungi prezzo
                </button>
            </div>
        </div>
    </ng-template>
    <ng-template pTemplate="header" let-columns>
        <tr>
            <th class="w-1/12"></th>
            <th *ngFor="let col of columns;" class="w-3/12">{{col.header}}</th>
            <th class="w-2/12 text-center">Azioni</th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowData let-columns="columns" let-index="rowIndex">
        <tr [pReorderableRow]="index">
            <td class="text-center">
                <i class="bi bi-list text-2xl hover:text-black cursor-grab" pReorderableRowHandle></i>
            </td>
            <td *ngFor="let col of columns; let i = index">
               {{col.type == 'moneta' ? (rowData[col.value] != 0 ? (rowData[col.value] | currency: 'EUR') : '-') : (rowData[col.value] | titlecase)}}
            </td>
            <td class="text-center">
                <div class="table-actions">
                    <i class="bi bi-pencil" (click)="onOpenEdit(rowData)" pTooltip="Modifica" tooltipPosition="bottom"></i>
                    <p-divider layout="vertical"></p-divider>
                    <ng-container *ngIf="rowData.id">
                        <p-confirmPopup #delete>
                            <ng-template pTemplate="headless" let-message>
                                <div class="border-round p-3">
                                    <span class="text-base">{{ message.message }}</span>
                                    <div class="flex align-items-center gap-2 mt-3">
                                        <button type="button" class="acc-btn flex-1" (click)="onDeletePrezzo()">Elimina</button>
                                        <button type="button" class="acc-btn acc-btn-ghost flex-1" (click)="onAnnullaDeletePrezzo()">Annulla</button>
                                    </div>
                                </div>
                            </ng-template>
                        </p-confirmPopup>
                        <i class="bi bi-trash" (click)="onOpenDeletePrezzo($event, rowData, index)" pTooltip="Elimina" tooltipPosition="bottom"></i>
                    </ng-container>
                    <ng-container *ngIf="!rowData.id">
                        <i class="bi bi-trash" (click)="prezzi.splice(index, 1)" pTooltip="Elimina" tooltipPosition="bottom"></i>
                    </ng-container>
                </div>
            </td>
        </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
        <tr>
            <td [attr.colspan]="colonne.length + 2">Nessuno prezzo presente.</td>
        </tr>
    </ng-template>
</p-table>

<p-dialog [visible]="(add || edit)" [style]="{width: '50%'}" [header]="add ? 'Aggiungi prezzi' : 'Modifica prezzo'" [modal]="true" styleClass="accrediti-dialog" (visibleChange)="onCloseModal()">
    <ng-template pTemplate="content">
        <form [formGroup]="formPrezzo" class="accrediti-form flex flex-col gap-6" (ngSubmit)="add ? onAdd() : onEdit()">
            <ng-container *ngFor="let colonna of colonne; let i = index">
                <div class="fld">
                    <label>{{colonna.header}}</label>
                    <p-autoComplete [formControlName]="colonna.value" [suggestions]="settori_filtrati" field="settore" appendTo="body" class="autocomplete w-full" [showEmptyMessage]="false" [dropdown]="true" (completeMethod)="onFilterSettori($event)" *ngIf="colonna.type == 'settore'" />
                    <p-inputNumber [formControlName]="colonna.value" mode="currency" currency="EUR" locale="it-IT" [maxFractionDigits]="2" *ngIf="colonna.type == 'moneta'" styleClass="w-full" />
                </div>
            </ng-container>
            <div class="acc-actions">
                <button type="button" class="acc-btn acc-btn-ghost" (click)="onCloseModal()">Annulla</button>
                <button type="submit" class="acc-btn acc-btn-primary" [disabled]="!formPrezzo.valid">{{add ? 'Aggiungi' : 'Modifica'}}</button>
            </div>
        </form>
    </ng-template>
</p-dialog>
